/* ============================================================
   NORTHSHEEP — Shipping & returns block

   Two jobs:
   1. Turn "2–4 working days" into a real window ("16–18 September") per
      country, using window.NsDelivery — the same helper as the buy-box
      delivery line, so the cut-off, the timezone, the skipped weekends and
      the day-first European format are identical everywhere.
   2. Keep each country's free-shipping bar true to the live cart. The block
      is rendered with the cart at page load; adding something from this page
      does not re-render it, so the bar is repainted from /cart.js whenever
      the cart changes. Each country has its own threshold (the NL store:
      free from €50 to the Netherlands, from €75 to Belgium), so each bar is
      worked out on its own.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsShippingInfo) return;
  window.__nsShippingInfo = true;

  function fillDates() {
    if (!window.NsDelivery) return;
    var els = document.querySelectorAll('[data-ns-ship-date]:not([data-ns-filled])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      try {
        var range = window.NsDelivery.computeRange({
          min: parseInt(el.getAttribute('data-min'), 10) || 1,
          max: parseInt(el.getAttribute('data-max'), 10) || 3,
          // An EMPTY cut-off means "no cut-off" — the promise is 24 hours, not
          // a clock time. `|| '12:00'` treated empty as noon, so after midday
          // this block quoted a day later than the buy box did.
          cutoff: el.getAttribute('data-cutoff') || '',
          tz: el.getAttribute('data-tz') || 'Europe/Amsterdam',
        });
        var locale = el.getAttribute('data-locale') || document.documentElement.lang || 'en';
        el.textContent = window.NsDelivery.fmtRange(range.start, range.end, locale);
        el.setAttribute('data-ns-filled', '');
      } catch (e) {
        /* a date is a nicety; the "2–4 working days" line is already there */
      }
    }
  }

  /* The money format is the store's own, so it is taken from the text the
     server already rendered rather than rebuilt here: swap the amount inside
     it. The server wrote "Nog € 24,05 tot gratis verzending"; only the amount
     changes as the cart does. */
  function formatAmount(cents, sample) {
    var value = (cents / 100).toFixed(2);
    var m = sample && sample.match(/(\D*)(\d[\d.,\s]*)(\D*)$/);
    if (!m) return value;
    var decimalComma = /,\d{2}\b/.test(sample);
    var body = decimalComma ? value.replace('.', ',') : value;
    return sample.replace(m[2].trim(), body);
  }

  function paint(cartTotal) {
    var blocks = document.querySelectorAll('[data-ns-ship-progress]');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var free = parseInt(block.getAttribute('data-free'), 10) || 0;
      if (!free) continue;
      // Shown from the first item on; an empty basket has nothing to measure.
      block.hidden = !(cartTotal > 0);
      var fill = block.querySelector('.ns-ship__fill');
      var text = block.querySelector('[data-ns-ship-progress-text]');
      var pct = Math.min(100, Math.round((cartTotal / free) * 100));
      if (fill) fill.style.width = pct + '%';
      var reached = cartTotal >= free && cartTotal > 0;
      block.classList.toggle('is-free', reached);
      if (!text) continue;
      if (reached) {
        if (!block.__nsAwayTemplate) block.__nsAwayTemplate = text.textContent;
        text.textContent = block.getAttribute('data-free-label') || text.textContent;
      } else {
        /* The "...to go" sentence comes from the server (data-away-template; audit,
           2 Oct 2026). A page that loaded with free delivery already reached had
           only "Your delivery is free" on screen to learn it from, kept that as
           the template and went on promising free delivery after the basket
           dropped below the threshold - against the owner's rule. */
        var template = block.getAttribute('data-away-template') || block.__nsAwayTemplate || text.textContent;
        block.__nsAwayTemplate = template;
        var amountMatch = template.match(/\D*\d[\d.,\s]*\D*/);
        if (amountMatch) {
          text.textContent = template.replace(
            amountMatch[0].trim(),
            formatAmount(free - cartTotal, amountMatch[0].trim())
          );
        }
      }
    }
  }

  function refresh() {
    if (!document.querySelector('[data-ns-ship-progress]')) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        paint(cart.total_price);
      })
      .catch(function () {});
  }

  function start() {
    fillDates();
    // The accordion opens later; a date that was not there yet gets filled.
    document.addEventListener('toggle', fillDates, true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
